class SlideoutCart {
  constructor() {
    console.group('SlideoutCart Initialization');
    this.cart = document.querySelector('[data-slideout-cart]');
    console.log('Cart element:', this.cart);

    if (!this.cart) {
      console.error('Cart element not found');
      console.groupEnd();
      return;
    }

    this.overlay = this.cart.querySelector('[data-cart-overlay]');
    this.closeButton = this.cart.querySelector('[data-cart-close]');
    this.itemsContainer = this.cart.querySelector('[data-cart-items]');
    this.subtotalElement = this.cart.querySelector('[data-cart-subtotal]');

    // Initialize cart state
    this.fetchCart();
    this.bindEvents();

    // Add quick shop button handling
    this.initQuickShop();

    // Add cart toggle button handling
    this.cartToggleButtons = [...document.querySelectorAll('[data-cart-toggle]')];
    console.log('this.cartToggleButtons', this.cartToggleButtons);
    if (this.cartToggleButtons.length > 0) {
      this.cartToggleButtons.forEach((button) => {
        button.addEventListener('click', this.openCart);
      });
    }

    // Add dev clear cart button if in development
    // if (window.location.hostname === '127.0.0.1' || window.location.hostname.includes('.myshopify.com')) {
    //   this.addDevClearCartButton();
    // }

    console.log('this.cart', this.cart);

    // Initialize dialog elements
    this.subscriptionDialog = this.cart.querySelector('[data-subscription-dialog]');
    this.dialogContent = this.subscriptionDialog?.querySelector('[data-dialog-content]');
    this.dialogOverlay = this.subscriptionDialog?.querySelector('[data-dialog-overlay]');
    this.dialogConfirm = this.subscriptionDialog?.querySelector('[data-dialog-confirm]');
    this.dialogCancel = this.subscriptionDialog?.querySelector('[data-dialog-cancel]');

    this.initDialogEvents();

    // Add checkout button handlers
    this.initCheckoutButtons();

    console.groupEnd();
  }

  bindEvents() {
    // Open cart
    this.openCart = () => {
      this.cart.classList.add('is-active');
      // Prevent background scrolling
      document.documentElement.style.overflow = 'hidden'; // HTML element
      document.body.style.overflow = 'hidden';

      document.querySelector('#chatbase-bubble-button').style.zIndex = '1';
    };

    // Close cart with animation
    this.closeCart = () => {
      // Start exit animation
      this.cart.classList.add('is-closing');

      // Wait for animation to complete before hiding
      setTimeout(() => {
        this.cart.classList.remove('is-active', 'is-closing');
        // Restore scrolling
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';

        document.querySelector('#chatbase-bubble-button').style.zIndex = 'initial';
      }, 300); // Match this with CSS transition duration
    };

    // Event listeners
    this.overlay.addEventListener('click', this.closeCart);
    this.closeButton.addEventListener('click', this.closeCart);

    // Quantity buttons
    this.cart.addEventListener('click', async (e) => {
      const minusBtn = e.target.closest('[data-quantity-minus]');
      const plusBtn = e.target.closest('[data-quantity-plus]');
      const removeBtn = e.target.closest('[data-cart-remove]');

      if (minusBtn || plusBtn) {
        const item = e.target.closest('[data-cart-item]');
        const lineItemKey = item.dataset.lineItemKey;

        // Get current cart state
        const response = await fetch('/cart.js');
        const cart = await response.json();

        // Find the current quantity for this line item
        const lineItem = cart.items.find((item) => item.key === lineItemKey);
        if (!lineItem) return;

        // Calculate new quantity
        const currentQty = lineItem.quantity;
        const newQty = plusBtn ? currentQty + 1 : Math.max(1, currentQty - 1);

        // Prevent unnecessary updates
        if (currentQty === newQty) return;

        // Update cart with new quantity
        await this.updateQuantity(lineItemKey, newQty);

        // Update input value to match cart
        const input = item.querySelector('[data-quantity-input]');
        if (input) {
          input.value = newQty;
        }
      }

      if (removeBtn) {
        const item = e.target.closest('[data-cart-item]');
        const lineItemKey = item.dataset.lineItemKey;

        // Get current cart state to find associated subscription
        const response = await fetch('/cart.js');
        const cart = await response.json();

        // Find the current item
        const currentItem = cart.items.find((item) => item.key === lineItemKey);

        // Find associated subscription item if it exists
        const subscriptionItem = cart.items.find(
          (item) =>
            item.properties?._product_type === 'subscription' && item.properties?._parent_product === currentItem.handle
        );

        // Remove both items
        await this.updateQuantity(lineItemKey, 0);
        if (subscriptionItem) {
          await this.updateQuantity(subscriptionItem.key, 0);
        }
      }
    });
  }

  initQuickShop() {
    // Only listen for checkout button clicks directly
    const checkoutButtons = document.querySelectorAll('[data-subscription-checkout]');

    checkoutButtons.forEach((button) => {
      button.addEventListener('click', async (e) => {
        // Stop propagation to prevent document-level handlers from interfering
        e.stopPropagation();
        e.preventDefault();
        await this.handleSubscriptionCheckout(e.currentTarget);
      });
    });

    // For quick shop buttons, use a more specific selector
    const quickShopContainer = document.querySelector('[data-quick-shop-container]');
    if (quickShopContainer) {
      quickShopContainer.addEventListener('click', async (e) => {
        const quickShopBtn = e.target.closest('[data-quick-shop]');
        if (!quickShopBtn) return;

        // Don't handle if it's inside a variant selector
        if (quickShopBtn.closest('lazer-variant-selector')) return;

        const variantId = quickShopBtn.dataset.variantId;
        const quantity = 1;
        const properties = {};

        Object.entries(quickShopBtn.dataset).forEach(([key, value]) => {
          if (key.startsWith('property')) {
            const propertyKey = key
              .replace('property', '')
              .replace(/([A-Z])/g, '_$1')
              .toLowerCase()
              .replace(/^_/, '');
            properties[propertyKey] = value;
          }
        });

        quickShopBtn.disabled = true;
        try {
          await this.addToCart(variantId, quantity, properties);
          this.openCart();
        } catch (error) {
          console.error('Error adding to cart:', error);
        } finally {
          quickShopBtn.disabled = false;
        }
      });
    }
  }

  initDialogEvents() {
    // Close dialog on overlay click
    this.dialogOverlay?.addEventListener('click', () => {
      this.closeDialog();
    });

    // Close dialog on cancel button
    this.dialogCancel?.addEventListener('click', () => {
      this.closeDialog();
    });

    // Handle ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.subscriptionDialog?.classList.contains('tw-flex')) {
        this.closeDialog();
      }
    });
  }

  openDialog() {
    this.subscriptionDialog?.classList.remove('tw-hidden');
    this.subscriptionDialog?.classList.add('tw-flex');
    document.body.style.overflow = 'hidden';
  }

  closeDialog() {
    this.subscriptionDialog?.classList.remove('tw-flex');
    this.subscriptionDialog?.classList.add('tw-hidden');
    document.body.style.overflow = '';
  }

  showSubscriptionDialog() {
    return new Promise((resolve) => {
      const animateIn = () => {
        this.subscriptionDialog.classList.remove('tw-hidden');
        this.subscriptionDialog.classList.add('tw-flex');
        document.body.style.overflow = 'hidden';

        requestAnimationFrame(() => {
          this.dialogOverlay.classList.add('tw-opacity-50');
          this.dialogContent.classList.remove('tw-opacity-0', 'tw-translate-y-4');
        });
      };

      const animateOut = () => {
        return new Promise((resolveAnimation) => {
          this.dialogOverlay.classList.remove('tw-opacity-50');
          this.dialogContent.classList.add('tw-opacity-0', 'tw-translate-y-4');

          setTimeout(() => {
            this.subscriptionDialog.classList.add('tw-hidden');
            this.subscriptionDialog.classList.remove('tw-flex');
            document.body.style.overflow = '';
            resolveAnimation();
          }, 300);
        });
      };

      const handleConfirm = async () => {
        await animateOut();
        cleanup();
        resolve(true);
      };

      const handleCancel = async () => {
        await animateOut();
        cleanup();
        resolve(false);
      };

      const handleOverlay = async () => {
        await animateOut();
        cleanup();
        resolve(false);
      };

      const handleEscape = async (e) => {
        if (e.key === 'Escape') {
          await animateOut();
          cleanup();
          resolve(false);
        }
      };

      const cleanup = () => {
        this.dialogConfirm.removeEventListener('click', handleConfirm);
        this.dialogCancel.removeEventListener('click', handleCancel);
        this.dialogOverlay.removeEventListener('click', handleOverlay);
        document.removeEventListener('keydown', handleEscape);
      };

      // Add event listeners
      this.dialogConfirm.addEventListener('click', handleConfirm);
      this.dialogCancel.addEventListener('click', handleCancel);
      this.dialogOverlay.addEventListener('click', handleOverlay);
      document.addEventListener('keydown', handleEscape);

      // Start the animation
      animateIn();
    });
  }

  async getCart() {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    return cart;
  }

  async handleSubscriptionCheckout(button) {
    console.group('Subscription Checkout');
    console.log('Button clicked:', button);

    try {
      const cart = await this.getCart();
      console.log('Current cart:', cart);

      const existingSubscription =
        cart.items.find((item) => item.properties?._product_type === 'subscription') ||
        cart.items.find((item) => item.properties?._is_suit === 'true');
      console.log('Existing subscription:', existingSubscription);

      // Get the variant selector component
      const variantSelector = button.closest('lazer-variant-selector');
      console.log('Variant selector:', variantSelector);

      if (!variantSelector) {
        console.error('No variant selector found');
        return;
      }

      // Get dialog elements from variant selector
      const dialog = variantSelector.querySelector('[data-subscription-dialog]');
      const dialogContent = dialog?.querySelector('[data-dialog-content]');
      const dialogOverlay = dialog?.querySelector('[data-dialog-overlay]');
      const dialogConfirm = dialog?.querySelector('[data-dialog-confirm]');
      const dialogCancel = dialog?.querySelector('[data-dialog-cancel]');

      console.log('Dialog elements:', {
        dialog,
        content: dialogContent,
        overlay: dialogOverlay,
        confirm: dialogConfirm,
        cancel: dialogCancel,
      });

      // Get selected variants from the component
      const selectedProduct = variantSelector.querySelector('[data-product-handle].selected');
      const selectedSubscription = variantSelector.querySelector('.subscription-variant.selected');

      if (!selectedProduct || !selectedSubscription) {
        console.error('Missing selected variants', {
          selectedProduct,
          selectedSubscription,
        });
        return;
      }

      const productVariantId = selectedProduct.dataset.variantId;
      const subscriptionVariantId = selectedSubscription.dataset.variantId;
      const productHandle = selectedProduct.dataset.productHandle;
      const alternativeVariantId = selectedSubscription.dataset.variantIdAlternative;
      const sellingPlanId = selectedSubscription.dataset.sellingPlanId;

      const quantity = 1;
      const productProperties = {
        _is_suit: 'true',
        _has_subscription: 'true',
      };

      const subscriptionProperties = {
        _product_type: 'subscription',
        _parent_product: productHandle,
        _alternative_variant_id: alternativeVariantId,
        _selling_plan_id: sellingPlanId,
      };

      button.disabled = true;

      if (!existingSubscription || cart.items.length === 0) {
        await this.addSubscriptionBundle(
          productVariantId,
          subscriptionVariantId,
          productProperties,
          subscriptionProperties,
          quantity
        );
        this.openCart();
      } else {
        // Show dialog using local elements
        const confirmed = await new Promise((resolve) => {
          if (!dialog || !dialogContent || !dialogOverlay || !dialogConfirm || !dialogCancel) {
            console.error('Missing dialog elements, falling back to window.confirm');
            resolve(
              window.confirm(
                'You can only have one subscription product in your cart. Would you like to replace your current subscription with this one?'
              )
            );
            return;
          }

          const animateIn = () => {
            console.log('Animating dialog in');
            dialog.classList.remove('tw-hidden');
            dialog.classList.add('tw-flex');
            document.body.style.overflow = 'hidden';

            requestAnimationFrame(() => {
              dialogOverlay.classList.add('tw-opacity-50');
              dialogContent.classList.remove('tw-opacity-0', 'tw-translate-y-4');
            });
          };

          const animateOut = () => {
            console.log('Animating dialog out');
            return new Promise((resolveAnimation) => {
              dialogOverlay.classList.remove('tw-opacity-50');
              dialogContent.classList.add('tw-opacity-0', 'tw-translate-y-4');

              setTimeout(() => {
                dialog.classList.add('tw-hidden');
                dialog.classList.remove('tw-flex');
                document.body.style.overflow = '';
                resolveAnimation();
              }, 300);
            });
          };

          const handleConfirm = async () => {
            console.log('Dialog confirmed');
            await animateOut();
            cleanup();
            resolve(true);
          };

          const handleCancel = async () => {
            console.log('Dialog cancelled');
            await animateOut();
            cleanup();
            resolve(false);
          };

          const cleanup = () => {
            console.log('Cleaning up dialog listeners');
            dialogConfirm.removeEventListener('click', handleConfirm);
            dialogCancel.removeEventListener('click', handleCancel);
            dialogOverlay.removeEventListener('click', handleCancel);
            document.removeEventListener('keydown', handleEscape);
          };

          const handleEscape = (e) => {
            if (e.key === 'Escape') {
              handleCancel();
            }
          };

          // Add event listeners
          dialogConfirm.addEventListener('click', handleConfirm);
          dialogCancel.addEventListener('click', handleCancel);
          dialogOverlay.addEventListener('click', handleCancel);
          document.addEventListener('keydown', handleEscape);

          // Start animation
          animateIn();
        });

        console.log('Dialog result:', confirmed);

        if (confirmed) {
          const parentProduct = cart.items.find(
            (item) => item.handle === existingSubscription.properties?._parent_product
          );

          if (parentProduct) {
            await this.updateQuantity(parentProduct.key, 0);
          }
          await this.updateQuantity(existingSubscription.key, 0);

          await this.addSubscriptionBundle(
            productVariantId,
            subscriptionVariantId,
            productProperties,
            subscriptionProperties,
            quantity
          );
          this.openCart();
        } else {
          // Re-enable the button if the dialog was cancelled
          button.disabled = false;
          return; // Exit early to prevent the finally block from running twice
        }
      }
    } catch (error) {
      console.error('Error in subscription checkout:', error);
    } finally {
      button.disabled = false;
      console.groupEnd();
    }
  }

  async addSubscriptionBundle(
    productVariantId,
    subscriptionVariantId,
    productProperties,
    subscriptionProperties,
    quantity
  ) {
    // Add original variant ID to subscription properties
    const enhancedSubscriptionProperties = {
      ...subscriptionProperties,
      _original_variant_id: subscriptionVariantId,
    };

    const cartData = {
      items: [
        {
          id: productVariantId,
          quantity: quantity,
          properties: productProperties,
        },
        {
          id: subscriptionVariantId,
          quantity: quantity,
          properties: enhancedSubscriptionProperties,
          selling_plan: subscriptionProperties._selling_plan_id,
        },
      ],
    };

    console.log('cartData', cartData);

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(cartData),
    });

    if (!response.ok) {
      throw new Error('Add to cart failed');
    }

    const cart = await fetch('/cart.js').then((res) => res.json());
    this.updateCart(cart);
    this.checkMultipleSuits(cart);
    this.openCart();

    this.updateCartToggleContainer(cart);
  }

  async addToCart(variantId, quantity, properties = {}) {
    console.group('Add to Cart');
    console.log('Initial params:', { variantId, quantity, properties });

    try {
      // Get the button that triggered the add to cart
      const button = document.querySelector(`[data-variant-id="${variantId}"]`);
      console.log('Found button:', button);
      console.log('Button dataset:', button?.dataset);

      const isSuit = button?.dataset.isSuit === 'true';
      console.log('Is suit product:', isSuit);

      if (isSuit) {
        console.log('Processing suit product...');
        // Check current cart for suits/subscriptions
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        console.log('Current cart:', cart);

        const hasSuitOrSubscription = cart.items.some(
          (item) => item.properties?._is_suit === 'true' || item.properties?._product_type === 'subscription'
        );
        console.log('Has existing suit or subscription:', hasSuitOrSubscription);

        if (hasSuitOrSubscription) {
          console.log('Showing suit dialog...');
          // Get the suit dialog
          const suitDialog = document.getElementById('suit-dialog');
          if (!suitDialog) {
            console.error('Suit dialog not found');
            return;
          }

          // Show the dialog

          suitDialog.open();

          // Wait for user response
          const confirmed = await new Promise((resolve) => {
            const handleConfirm = () => {
              cleanup();
              resolve(true);
            };

            const handleCancel = () => {
              cleanup();
              resolve(false);
            };

            const cleanup = () => {
              suitDialog.close();
              suitDialog.removeEventListener('click', handleConfirm);
              document.removeEventListener('keydown', handleEscape);
            };

            const handleEscape = (e) => {
              if (e.key === 'Escape') handleCancel();
            };

            suitDialog.querySelector('[data-dialog-confirm]')?.addEventListener('click', handleConfirm);
            suitDialog.querySelector('[data-dialog-cancel]')?.addEventListener('click', handleCancel);
            suitDialog.querySelector('[data-dialog-overlay]')?.addEventListener('click', handleCancel);
            document.addEventListener('keydown', handleEscape);
          });

          console.log('Dialog result:', confirmed);

          if (!confirmed) {
            console.log('User cancelled dialog');
            console.groupEnd();
            return;
          }

          console.log('Clearing cart...');
          // Clear cart if confirmed
          for (const item of cart.items) {
            await this.updateQuantity(item.key, 0);
          }
        }

        // Add is-suit property to the item
        properties._is_suit = 'true';
        console.log('Updated properties with is-suit:', properties);
      }

      // Rest of the add to cart logic...
      const cartData = {
        items: [
          {
            id: variantId,
            quantity: quantity,
            properties: properties,
          },
        ],
      };
      console.log('Cart data to be added:', cartData);

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(cartData),
      });

      if (!response.ok) {
        console.log('Add to cart response:', response);
        throw new Error('Add to cart failed', response);
      }

      const updatedCart = await fetch('/cart.js').then((res) => res.json());
      console.log('Updated cart:', updatedCart);
      this.updateCart(updatedCart);
      this.openCart();
    } catch (error) {
      console.error('Error adding to cart:', error);
    } finally {
      console.groupEnd();
    }
  }

  async fetchCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      this.updateCart(cart);
    } catch (error) {
      console.error('Error fetching cart:', error);
    }
  }

  async updateCart(cart) {
    // First, check for and remove any orphaned subscription products
    const orphanedSubscriptions = cart.items.filter((item) => {
      if (item.properties?._product_type !== 'subscription') return false;

      // Check if parent product exists
      const hasParent = cart.items.some(
        (parentItem) => parentItem.handle === item.properties._parent_product && !parentItem.properties?._product_type
      );
      return !hasParent;
    });

    // Remove any orphaned subscriptions
    for (const item of orphanedSubscriptions) {
      await this.updateQuantity(item.key, 0);
      cart = await fetch('/cart.js').then((res) => res.json());
    }

    // Check for multiple suits using the reusable function
    this.checkMultipleSuits(cart);

    // Update cart toggle container with filtered item count
    this.updateCartToggleContainer(cart);

    // Continue with existing cart update logic
    this.updateTrueMedButtonVisibility(cart);
    this.subtotalElement.textContent = this.formatMoney(cart.total_price);

    // Show empty state if no items
    const footer = this.cart.querySelector('.slideout-cart__footer');
    if (cart.item_count === 0) {
      this.itemsContainer.innerHTML = `
        <div class='slideout-cart__empty' data-cart-empty>
          Your cart is empty
        </div>
      `;
      if (footer) footer.classList.add('hidden');
      return;
    }

    // Show footer when items exist
    if (footer) footer.classList.remove('hidden');

    // Group items by parent product, hiding subscription items
    const groupedItems = cart.items.reduce((acc, item) => {
      // Skip subscription items as standalone entries
      if (item.properties?._product_type === 'subscription') {
        return acc;
      }

      // Find the associated subscription item
      const subscriptionItem = cart.items.find(
        (subItem) =>
          subItem.properties?._product_type === 'subscription' && subItem.properties?._parent_product === item.handle
      );

      // Add the item with its subscription data
      acc.push({
        ...item,
        subscriptionData: subscriptionItem
          ? {
              variantId: subscriptionItem.variant_id,
              alternativeVariantId: subscriptionItem.properties._alternative_variant_id,
              sellingPlanId: subscriptionItem.properties._selling_plan_id,
              title: subscriptionItem.title,
            }
          : null,
      });

      return acc;
    }, []);

    // Render cart items
    this.itemsContainer.innerHTML = groupedItems
      .map((item) => {
        console.log('itemxxx', item);
        let isSuit = item.properties?._is_suit === 'true';
        let subscriptionHtml = '';
        if (item.subscriptionData) {
          subscriptionHtml = `
            <span class="p2">${item.subscriptionData.title
              .replace('Katalyst', '')
              .replace('- Billed monthly thereafter.', '')}</span>
          `;
        }

        return `
          <div class="slideout-cart__item tw-py-sm" data-cart-item data-line-item-key="${item.key}">
            <div class="slideout-cart__item-image">
              <a href="${item.url}">
                <img src="${item.image || ''}" alt="${item.title}">
              </a>
            </div>
            <div class="slideout-cart__item-content">


              <div class="slideout-cart__item-title-group">
                <div class="slideout-cart__item-title-group-top">
                <h3 class="slideout-cart__item-title p3">
                  <a href="${item.url}">${item.title}</a>
                </h3>
              <div class="slideout-cart__item-controls tw-flex tw-gap-xs tw-mt-xs">
                ${
                  item.subscriptionData
                    ? `<div class="slideout-cart__item-subscription p2">
                  ${subscriptionHtml}
                </div>`
                    : ''
                }
                    
                ${
                  !isSuit
                    ? `<div class="slideout-cart__item-quantity ${item.subscriptionData ? 'hidden' : ''}">
                  <button data-quantity-minus>-</button>
                  <input type="text" 
                    data-quantity-input 
                    class="slideout-cart__item-quantity-input p2"
                    value="${item.quantity}" 
                    readonly
                    aria-label="Quantity">
                  <button data-quantity-plus>+</button>
                </div>`
                    : ''
                }
              </div>
              </div>

              <button class="slideout-cart__item-remove ${
                item.subscriptionData ? 'subscription-remove' : ''
              }" data-cart-remove>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash-2"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
                  <span class="p1">Remove</span>
                </button>
              </div>
              <div class="slideout-cart__item-price-group">
                <div class="slideout-cart__item-price p2">${this.formatMoney(item.final_line_price)}</div>
              </div>
            </div>
          </div>
        `;
      })
      .join('');

    // Update footer
    if (footer) {
      let giftInfoHtml = '';
      if (cart.attributes?._giftRecipient) {
        try {
          const giftData = JSON.parse(cart.attributes._giftRecipient);
          giftInfoHtml = `
            <div class="slideout-cart__gift-info tw-mb-sm tw-border tw-border-primary-mid-black tw-p-sm tw-bg-primary-light-gray tw-rounded">
              <div class="tw-flex tw-items-center tw-gap-xs tw-mb-xs">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M20 12v10H4V12M22 7H2v5h20V7zM12 22V7M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/>
                </svg>
                <p class="p3">Sending as a gift to ${giftData.name}</p>
              </div>
              <p class="p2 tw-text-gray-600">Delivery date: ${new Date(giftData.date).toLocaleDateString()}</p>
              <button class="tw-text-primary-brand-red tw-text-sm tw-mt-xs tw-underline" data-remove-gift>Remove gift details</button>
            </div>
          `;

          // Hide the "Is this a gift?" button when gift info is present
          footer.querySelector('.slideout-cart__gift-toggle')?.classList.add('hidden');
        } catch (error) {
          console.error('Error parsing gift data:', error);
        }
      } else {
        // Show the "Is this a gift?" button when no gift info is present
        footer.querySelector('.slideout-cart__gift-toggle')?.classList.remove('hidden');
      }

      // Insert gift info before the subtotal
      const subtotalElement = footer.querySelector('.slideout-cart__subtotal');
      if (subtotalElement) {
        const existingGiftInfo = footer.querySelector('.slideout-cart__gift-info');
        if (existingGiftInfo) {
          existingGiftInfo.remove();
        }
        if (giftInfoHtml) {
          subtotalElement.insertAdjacentHTML('beforebegin', giftInfoHtml);

          // Add event listener for remove button
          footer.querySelector('[data-remove-gift]')?.addEventListener('click', async () => {
            await fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                attributes: {
                  _giftRecipient: '',
                },
              }),
            });
            this.fetchCart();
          });
        }
      }
    }
  }

  updateTrueMedButtonVisibility(cart) {
    console.log('cart', cart);
    const hasGiftCard = cart.items.some((item) => item.product_type === 'Gift Card');
    const trueMedButton = this.cart.querySelector('[data-checkout-alternative');

    if (trueMedButton) {
      trueMedButton.parentElement.classList.toggle('tw-hidden', hasGiftCard);
    }
  }

  async updateQuantity(lineItemKey, quantity) {
    const item = this.cart.querySelector(`[data-line-item-key="${lineItemKey}"]`);
    if (item) {
      item.classList.add('is-loading');
    }

    try {
      // Get current cart state to find associated subscription
      const cartResponse = await fetch('/cart.js');
      if (!cartResponse.ok) {
        throw new Error(`Failed to fetch cart: ${cartResponse.status}`);
      }
      const cart = await cartResponse.json();

      // Find the current item
      const currentItem = cart.items.find((item) => item.key === lineItemKey);

      // If we're removing an item (quantity = 0), check for associated subscription
      if (quantity === 0 && currentItem) {
        const subscriptionItem = cart.items.find(
          (item) =>
            item.properties?._product_type === 'subscription' && item.properties?._parent_product === currentItem.handle
        );

        // If there's an associated subscription, remove it first
        if (subscriptionItem) {
          const subResponse = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: subscriptionItem.key,
              quantity: 0,
            }),
          });

          if (!subResponse.ok) {
            console.error('Failed to remove subscription:', await subResponse.text());
            throw new Error(`Failed to remove subscription: ${subResponse.status}`);
          }

          await subResponse.json(); // Wait for the subscription removal to complete
        }
      }

      // Update the original item
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: lineItemKey,
          quantity: quantity,
        }),
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Cart update failed:', errorText);
        throw new Error(`Failed to update cart: ${response.status} - ${errorText}`);
      }

      const result = await response.json();

      this.updateCart(result);
    } catch (error) {
      console.error('Update quantity error:', error);
      throw error; // Re-throw the error to be handled by the caller
    } finally {
      if (item) {
        item.classList.remove('is-loading');
      }
      console.groupEnd();
    }
  }

  formatMoney(cents) {
    return (cents / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
  }

  addDevClearCartButton() {
    const footer = this.cart.querySelector('.slideout-cart__footer');
    if (!footer) return;

    const clearButton = document.createElement('button');
    clearButton.textContent = '🧹 Clear Cart (Dev)';
    clearButton.className = 'slideout-cart__dev-clear-button';
    clearButton.style.cssText =
      'background: #ff4444; color: white; padding: 8px 16px; border-radius: 4px; margin-top: 10px; width: 100%;';

    clearButton.addEventListener('click', async () => {
      try {
        await fetch('/cart/clear.js', { method: 'POST' });
        await this.fetchCart();
      } catch (error) {
        console.error('Error clearing cart:', error);
      }
    });

    footer.appendChild(clearButton);
  }

  updateCartToggleContainer(cart) {
    const cartToggleContainers = [...document.querySelectorAll('[data-cart-toggle-container]')];
    const mobileCta = document.querySelector('.mobile-nav .mobile-cta');
    if (cartToggleContainers.length > 0) {
      // Filter out subscription products from the count
      const visibleItemCount = cart.items.filter((item) => !item.properties?._product_type).length;

      if (visibleItemCount > 0) {
        cartToggleContainers.forEach((container) => {
          container.classList.remove('tw-hidden');
          container.querySelector('span').textContent = `(${visibleItemCount})`;
        });
        if (mobileCta) {
          mobileCta.classList.add('tw-hidden');
        }
      } else {
        cartToggleContainers.forEach((container) => {
          container.classList.add('tw-hidden');
        });
        if (mobileCta) {
          mobileCta.classList.remove('tw-hidden');
        }
      }
    }
  }

  initCheckoutButtons() {
    const normalCheckout = this.cart.querySelector('[data-checkout-normal]');
    const alternativeCheckout = this.cart.querySelector('[data-checkout-alternative]');

    if (normalCheckout) {
      normalCheckout.addEventListener('click', (e) => this.handleCheckout(e, false));
    }
    if (alternativeCheckout) {
      alternativeCheckout.addEventListener('click', (e) => this.handleCheckout(e, true));
    }
  }

  async handleCheckout(event, isAlternativePayment) {
    event.preventDefault();

    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      // Handle subscription variants for both checkout types
      for (const item of cart.items) {
        if (item.properties?._product_type === 'subscription') {
          await this.updateQuantity(item.key, 0);

          const cartData = {
            items: [
              {
                id: item.properties._alternative_variant_id,
                quantity: 1,
                properties: {
                  _product_type: 'subscription',
                  _parent_product: item.properties._parent_product,
                  _alternative_variant_id: item.properties._alternative_variant_id,
                  _original_variant_id: item.properties._original_variant_id,
                  // Always preserve the selling plan ID in properties
                  _selling_plan_id: item.properties._selling_plan_id,
                },
                // Only include selling_plan field for normal checkout
                ...(isAlternativePayment ? {} : { selling_plan: item.properties._selling_plan_id }),
              },
            ],
          };

          await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(cartData),
          });
        }
      }

      // Get locale information
      const shopifyLocale = Shopify?.locale || '';
      const locale = shopifyLocale;

      // Build checkout params - always include locale and market
      const params = new URLSearchParams({
        locale,
        ...(isAlternativePayment && { skip_shop_pay: 'true' }),
      });

      window.location.href = `/checkout?${params.toString()}`;
    } catch (error) {
      console.error('Error during checkout:', error);
    }
  }

  // Add new method to check for multiple suits
  checkMultipleSuits(cart) {
    console.log('cart', cart);
    const suitItems = cart.items.filter((item) => item.properties?._is_suit === 'true');
    const hasMultipleSuits = suitItems.length > 1;

    if (hasMultipleSuits) {
      console.log('Multiple suits detected in cart:', suitItems);
      this.cart.querySelector('.slideout-cart__footer-overlay').classList.remove('tw-hidden');
    } else {
      console.log('No multiple suits detected in cart');
      this.cart.querySelector('.slideout-cart__footer-overlay').classList.add('tw-hidden');
    }

    return hasMultipleSuits;
  }
}
// Initialize the cart
document.addEventListener('DOMContentLoaded', () => {
  window.slideoutCart = new SlideoutCart();
});
